import { Routes, Route, Navigate } from 'react-router-dom'
import { Admin } from '../pages/admin'
import { LoginPage } from '../pages/LoginPage'
import { ProductAdministration } from '../pages/productAdministration'
import { isAdminTokenValid } from '../auth/auth.support'

const ProtectedRoute = ({ children }: { children: JSX.Element }): JSX.Element =>
  isAdminTokenValid() ? children : <Navigate to="/login" replace />

export const Router = (): JSX.Element => (
  <Routes>
    <Route path="/login" element={<LoginPage />} />
    <Route path="/" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
    <Route path="/product-administration" element={<ProtectedRoute><ProductAdministration /></ProtectedRoute>} />
  </Routes>
)
